import moment from 'moment'

import flatten from 'lodash/flatten'
import concat from 'lodash/concat'
import uniqBy from 'lodash/uniqBy'
import forOwn from 'lodash/forOwn'
import isEmpty from 'lodash/isEmpty'
import keys from 'lodash/keys'
import findIndex from 'lodash/findIndex'

import { ItalianRegions } from '../../../libs/ItalianRegions'
import { DataTypes } from '../../../libs/DataTypes'
import { DataTypeDataKeyOrder } from '../../../libs/DataUtilities'

import Papa from 'papaparse'
import csvData from './../../../assets/csv_data/idd_data.csv'

/* Random Generated Data */

/*
const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const DataTypesDataGenerator = {
    'accommodations_in_italy': [
        {key: 'accommodations_in_italy', func: 'getRandomInt(1000, 10000)', measure_unit: '', source: 'istat'},
        // {key: 'percent_accommodations_in_italy_vs_italy', func: 'getRandomInt(1, 20)', measure_unit: '%', source: 'ta'}, 
    ],
    'total_accommodations': [
        {key: 'total_accommodations', func: 'getRandomInt(10000, 70000)', measure_unit: '', source: 'istat'},
        // {key: 'percent_total_accommodations_vs_italy', func: 'getRandomInt(1, 20)', measure_unit: '%', source: 'ta'}
    ],
    'online_accommodations': [{key: 'online_accommodations', func: 'getRandomInt(1000, 50000)', measure_unit: '', source: 'ta'}],
    'online_apartments': [{key: 'online_apartments', func: 'getRandomInt(1000, 50000)', measure_unit: '', source: 'ta'}],
    // 'percent_airbnb_accommodations': [{key: 'percent_airbnb_accommodations', func: 'getRandomInt(1, 100)', measure_unit: '%', source: 'airbnb'}],
    'economics_per_inhabitant': [{key: 'economics_per_inhabitant', func: 'getRandomInt(10, 200)', measure_unit: '€', source: 'airbnb'}],
    
    // 'accommodations_reviews':  [{key: 'accommodations_reviews', func: 'getRandomInt(10000, 100000)', measure_unit: '', source: 'ta'}],
    // 'apartments_reviews':  [{key: 'apartments_reviews', func: 'getRandomInt(10000, 100000)', measure_unit: '', source: 'ta'}],

    'accommodations_reviews': DataTypeDataKeyOrder['accommodations_reviews'].map((cs, i) => { return {key: cs, func: 'getRandomInt(10000, 100000)', measure_unit: '', source: 'ta'} }),
    'apartments_reviews': DataTypeDataKeyOrder['apartments_reviews'].map((cs, i) => { return {key: cs, func: 'getRandomInt(10000, 100000)', measure_unit: '', source: 'ta'} }),

    'percent_accommodation_satisfaction': [{key: 'percent_accommodation_satisfaction', func: 'getRandomInt(70, 90)', measure_unit: '%', source: 'ta'}],
    'percent_apartment_satisfaction': [{key: 'percent_apartment_satisfaction', func: 'getRandomInt(70, 90)', measure_unit: '%', source: 'ta'}],
    'percent_airbnb_5_stars_review': [{key: 'percent_airbnb_5_stars_review', func: 'getRandomInt(50, 90)', measure_unit: '%', source: 'airbnb'}],
    
    'total_arrivals': DataTypeDataKeyOrder['total_arrivals'].map((cs, i) => { return {key: cs, func: 'getRandomInt(150000, 2000000)', measure_unit: '', source: 'istat'} }),
    'percent_variance_arrivals': DataTypeDataKeyOrder['percent_variance_arrivals'].map((cs, i) => { return {key: cs, func: 'getRandomInt(1, 30)', measure_unit: '%', source: 'istat'} }),
    'total_attendances_airbnb': DataTypeDataKeyOrder['total_attendances_airbnb'].map((cs, i) => { return {key: cs, func: 'getRandomInt(10000, 100000)', measure_unit: '', source: 'airbnb'} }),
    'percent_variance_arrivals_airbnb': DataTypeDataKeyOrder['percent_variance_arrivals_airbnb'].map((cs, i) => { return {key: cs, func: 'getRandomInt(1, 30)', measure_unit: '%', source: 'airbnb'} })
}

let IddData = ItalianRegions.map((region, i) => {

    const allDataTypes = uniqBy(concat(DataTypes.accommodations, DataTypes.guestsSatisfactions, DataTypes.touristSource))

    return allDataTypes.map((dataType, j) => {

        let data = {
            "id": parseInt(`${i}${j}`),
            "region": region,
            "data_type": dataType,
            "data": DataTypesDataGenerator[dataType].map((g, i) => {
                return {
                    key: g.key,
                    value: eval(g.func),
                    measure_unit: g.measure_unit,
                    source: g.source
                }
            }),
            "year": 2017,
            "created_at": moment().format(),
            "updated_at": moment().format()
        }

        // Handle spoecific case of total_attendances_airbnb
        if(dataType == "total_attendances_airbnb") {
            data = {
                "id": parseInt(`${i}${j}`),
                "region": region,
                "data_type": dataType,
                "data": DataTypesDataGenerator[dataType].map((g, i) => {
                    if(g.key == "total_attendances_airbnb") {
                        return {
                            key: g.key,
                            value: eval(g.func),
                            measure_unit: g.measure_unit,
                            source: g.source
                        }
                    }
                    else {
                        return {
                            key: g.key,
                            value: null,
                            measure_unit: null,
                            source: g.source
                        }
                    }
                }),
                "year": 2017,
                "created_at": moment().format(),
                "updated_at": moment().format()
            }
        }

        return data
    })

})

IddData = flatten(IddData)

export default IddData
*/


/* CSV Data */
/*
const iddDataJson = [
    ["abruzzo","2,50%","1,50%","2.2","1,60%","0,90%","0,7","0.5%","0.3%","0.5%","0.5%","2.1%","2838","111314","1548653","1,50%","2,20%","0,30%","0,30%","0,30%","0,20%","8%","55%","0,53%","17","58%","1,40%","0,18%","0,20%","0,36%","0,24%","","","","","","","","","",""  ],
    ["basilicata","1,10%","0,80%","4.2","0,70%","0,90%","2,3","0.3%","0.7%","0.5%","0.7%","1.6%","1326","36072","786775","9,70%","1,10%","0,30%","0,10%","0,30%","0,30%","7%","41%","0,73%","12","63%","1,44%","0,72%","0,20%","0,00%","0,62%","","","","","","","","","",""  ],
    ["calabria","2,90%","1,40%","0.9","1,60%","0,90%","-0,3","0.9%","0.4%","0.4%","0.6%","1.3%","3361","193518","1799779","12,30%","2,40%","0,70%","0,60%","0,20%","0,30%","6%","76%","0,33%","10","55%","4,97%","3,25%","1,00%","1,99%","2,68%","","","","","","","","","",""  ],
    ["campania","6,00%","6,20%","0.7","6,00%","6,70%","0,2","4.5%","7.7%","11.9%","11.3%","7.0%","12804","232592","5641166","2,70%","5,00%","5,10%","1,90%","9,00%","7,70%","16%","59%","2,73%","40","57%","0,69%","0,23%","0,14%","0,13%","0,19%","","","","","","","","","",""  ],
    ["emilia_romagna","5,90%","7,10%","-0.9","3,40%","3,90%","0,8","3.7%","3.3%","4.0%","2.7%","8.8%","15639","458970","11051890","7,10%","12,90%","5,40%","4,00%","4,00%","2,20%","4%","45%","1,10%","28","57%","0,82%","0,23%","0,23%","0,51%","0,24%","","","","","","","","","",""  ],
    ["friuli_venezia_giulia","1,70%","2,00%","-0.2","1,20%","1,80%","-0,2","2.2%","0.5%","0.7%","0.8%","1.9%","7175","150886","2448834","5,50%","1,90%","0,70%","1,90%","0,60%","0,60%","3%","55%","1,38%","23","60%","5,35%","7,31%","8,71%","4,52%","8,26%","","","","","","","","","",""  ],
    ["lazio","8,30%","11,30%","-3","9,80%","15,20%","0,9","7.3%","10.7%","17.1%","22.6%","10.4%","18596","376209","11591827","1,50%","6,80%","9,80%","3,60%","14,40%","25,20%","21%","23%","4,52%","154","53%","6,80%","2,39%","2,00%","3,06%","3,48%","","","","","","","","","",""  ],
    ["liguria","2,40%","3,10%","-1.2","5,50%","6,10%","-1,4","3.4%","11.0%","3.1%","5.2%","4.0%","4938","154226","4739935","5,20%","4,10%","8,20%","2,60%","2,50%","3,50%","16%","40%","2,15%","146","57%","1,48%","0,36%","0,35%","1,10%","0,47%","","","","","","","","","",""  ],
    ["lombardy","8,40%","12,40%","-2.4","9,50%","12,10%","-0,8","16.6%","11.8%","12.5%","10.6%","11.8%","12225","383749","16557728","7,40%","11,80%","13,20%","11,80%","15,10%","11,50%","16%","38%","2,81%","51","54%","9,90%","16,18%","28,54%","13,69%","19,60%","","","","","","","","","",""  ],
    ["marche","3,10%","1,90%","1.9","1,90%","1,10%","1,2","0.7%","0.5%","0.7%","0.5%","2.6%","4652","193310","2117055","-10,90%","2,80%","0,50%","0,50%","0,50%","0,30%","6%","49%","1,13%","20","58%","6,45%","9,23%","6,30%","5,56%","3,81%","","","","","","","","","",""  ],
    ["molise","0,40%","0,20%","2.6","0,20%","0,10%","0,7","0.0%","0.0%","0.1%","0.2%","0.3%","508","11866","131050","-4,30%","0,20%","0,00%","0,00%","0,00%","0,00%","8%","67%","0,29%","4","59%","12,35%","11,94%","8,82%","17,24%","12,97%","","","","","","","","","",""  ],
    ["piedmont","4,60%","3,50%","1.2","4,20%","3,80%","0,9","3.6%","6.4%","2.8%","1.8%","4.1%","6704","198835","5179986","7,40%","5,10%","7,50%","3,20%","3,80%","1,70%","11%","43%","1,34%","28","59%","1,80%","0,30%","0,20%","0,51%","0,33%","","","","","","","","","",""  ],
    ["apulia","7,80%","4,60%","2","7,20%","4,00%","-0,2","2.3%","4.0%","3.3%","2.0%","5.2%","6883","272970","3911688","4,80%","4,80%","2,60%","1,20%","2,00%","1,10%","19%","49%","1,05%","31","59%","0,10%","0,02%","0,03%","0,02%","0,02%","","","","","","","","","",""  ],
    ["sardinia","5,50%","3,50%","0.9","7,20%","4,00%","0,2","4.5%","5.9%","3.2%","1.0%","2.8%","4844","211835","3097366","7,60%","2,60%","6,20%","2,90%","3,00%","0,50%","24%","52%","1,94%","130","56%","6,86%","5,32%","1,14%","2,83%","2,22%","","","","","","","","","",""  ],
    ["sicily","8,70%","6,70%","1.6","11,70%","8,50%","-0,2","7.6%","12.0%","7.6%","6.3%","6.6%","6750","203260","4857542","10,20%","4,30%","8,40%","2,50%","4,70%","3,70%","42%","39%","2,02%","57","57%","4,51%","6,87%","0,00%","6,63%","3,50%","","","","","","","","","",""  ],
    ["tuscany","12,20%","12,50%","-0.3","15,30%","14,10%","-0,4","9.3%","11.6%","13.4%","17.0%","11.7%","14011","559617","13601245","6,10%","9,80%","11,80%","7,00%","12,50%","18,40%","17%","33%","4,87%","190","55%","8,88%","10,10%","3,19%","8,52%","7,22%","","","","","","","","","",""  ],
    ["trentino_alto_adige","6,80%","5,50%","3.9","2,10%","1,90%","2","14.2%","0.7%","1.6%","1.3%","5.2%","13240","390861","11583192","5,00%","8,20%","1,70%","31,90%","3,80%","1,50%","3%","54%","0,56%","53","61%","2,64%","0,28%","0,59%","4,46%","0,69%","","","","","","","","","",""  ],
    ["umbria","3,00%","1,50%","2.8","2,40%","2,20%","1,1","0.6%","0.5%","0.9%","1.8%","2.6%","3998","88544","2125056","-10,30%","2,30%","0,80%","0,50%","1,20%","2,00%","17%","31%","2,41%","45","64%","14,73%","13,52%","22,06%","12,76%","17,35%","","","","","","","","","",""  ],
    ["aosta_valley","1,10%","0,90%","3.6","0,70%","0,60%","3,2","0.2%","1.0%","0.8%","0.3%","1.0%","1223","55295","1252213","4,20%","1,20%","2,30%","0,20%","2,10%","0,40%","9%","47%","1,99%","205","62%","1,58%","0,49%","0,87%","0,53%","0,90%","","","","","","","","","",""  ],
    ["veneto","7,70%","13,20%","-0.5","7,80%","11,20%","-0,2","17.5%","11.1%","14.9%","13.0%","9.1%","62945","750855","19172576","7,40%","10,60%","14,40%","23,40%","19,90%","18,90%","4%","40%","2,37%","83","54%","7,24%","11,10%","15,42%","15,59%","15,19%","","","","","","","","","",""  ],
    ["all","97145","9298460","84.20%","279252","3740806","90.60%","590136","473196","353227","176631","3773254","204660","5034784","123195556","5,30%","62672366","4547455","12202448","3607966","62672366","12%","37%","1,81%","68","56%","","","","","","","","","","","","","","",""  ]
]
*/
/*
const iddDataJsonColumns = [
    "region",
    "online_accommodations__ta_2018",
    "accommodations_reviews__ta_2018",
    "percent_accommodation_satisfaction__ta_2018",
    "online_apartments__ta_2018",
    "apartments_reviews__ta_2018",
    "percent_apartment_satisfaction__ta_2018",
    "total_reviews__ta_2018_germany",
    "total_reviews__ta_2018_france",
    "total_reviews__ta_2018_united-kingdom",
    "total_reviews__ta_2018_united-states",
    "total_reviews__ta_2018_italy",
    "accommodations_in_italy__istat_2017",
    "total_accommodations__istat_2017",
    "total_arrivals__istat_2017",
    "percent_variance_arrivals__istat_2017",
    "total_arrivals__istat_2017_italy",
    "total_arrivals__istat_2017_france",
    "total_arrivals__istat_2017_germany",
    "total_arrivals__istat_2017_united-kingdom",
    "total_arrivals__istat_2017_united-states",
    "percent_airbnb_accommodations__airbnb_2017",
    "percent_variance_arrivals_airbnb__airbnb_2017",
    "total_attendances_airbnb__airbnb_2017",
    "economics_per_inhabitant__airbnb_2017",
    "percent_airbnb_5_stars_review__airbnb_2017",
    "percent_variance_arrivals_airbnb__airbnb_2017_italy",
    "percent_variance_arrivals_airbnb__airbnb_2017_france",
    "percent_variance_arrivals_airbnb__airbnb_2017_united-states",
    "percent_variance_arrivals_airbnb__airbnb_2017_germany",
    "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom",
    "total_attendances_airbnb__airbnb_2017_italy",
    "total_attendances_airbnb__airbnb_2017_france",
    "total_attendances_airbnb__airbnb_2017_united-states",
    "total_attendances_airbnb__airbnb_2017_united-kingdom",
    "total_attendances_airbnb__airbnb_2017_germany",
    "percent_variance_arrivals__istat_2017_italy",
    "percent_variance_arrivals__istat_2017_france",
    "percent_variance_arrivals__istat_2017_united-states",
    "percent_variance_arrivals__istat_2017_united-kingdom",
    "percent_variance_arrivals__istat_2017_germany",
]
*/
/*
const derivationMap = {
    'accommodations_in_italy': ["accommodations_in_italy__istat_2017"],
    'total_accommodations': ["total_accommodations__istat_2017"],
    'online_accommodations': ["online_accommodations__ta_2018"],
    'online_apartments': ["online_apartments__ta_2018"],
    'economics_per_inhabitant': ["economics_per_inhabitant__airbnb_2017"],
    'percent_accommodation_satisfaction': ["percent_accommodation_satisfaction__ta_2018"],
    'percent_apartment_satisfaction': ["percent_apartment_satisfaction__ta_2018"],
    'percent_airbnb_5_stars_review': ["percent_airbnb_5_stars_review__airbnb_2017"],
    'total_arrivals': [
        "total_arrivals__istat_2017", 
        "total_arrivals__istat_2017_italy",
        "total_arrivals__istat_2017_france",
        "total_arrivals__istat_2017_germany",
        "total_arrivals__istat_2017_united-kingdom",
        "total_arrivals__istat_2017_united-states"
    ],
    'percent_variance_arrivals': [],
    'accommodations_reviews': ["accommodations_reviews__ta_2018"],
    'apartments_reviews': ["apartments_reviews__ta_2018"],
    'total_attendances_airbnb': [
        "total_attendances_airbnb__airbnb_2017",
        "total_attendances_airbnb__airbnb_2017_italy",
        "total_attendances_airbnb__airbnb_2017_france",
        "total_attendances_airbnb__airbnb_2017_united-states",
        "total_attendances_airbnb__airbnb_2017_united-kingdom",
        "total_attendances_airbnb__airbnb_2017_germany"
    ],
    'percent_variance_arrivals_airbnb': [
        "percent_variance_arrivals_airbnb__airbnb_2017",
        "percent_variance_arrivals_airbnb__airbnb_2017_italy",
        "percent_variance_arrivals_airbnb__airbnb_2017_france",
        "percent_variance_arrivals_airbnb__airbnb_2017_united-states",
        "percent_variance_arrivals_airbnb__airbnb_2017_germany",
        "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom"
    ]
}
*/

const iddDataJson = [
    {
      "region": "abruzzo",
      "online_accommodations__ta_2018": "2,50%",
      "accommodations_reviews__ta_2018": "1,50%",
      "percent_accommodation_satisfaction__ta_2018": "2.2%",
      "online_apartments__ta_2018": "1,60%",
      "apartments_reviews__ta_2018": "0,90%",
      "percent_apartment_satisfaction__ta_2018": "0,7%",
      "total_reviews__ta_2018": "2,40%",
      "total_reviews__ta_2018_germany": "0.5%",
      "total_reviews__ta_2018_france": "0.3%",
      "total_reviews__ta_2018_united-kingdom": "0.5%",
      "total_reviews__ta_2018_united-states": "0.5%",
      "total_reviews__ta_2018_italy": "2.1%",
      "accommodations_in_italy__istat_2017": "2838",
      "total_accommodations__istat_2017": "111314",
      "total_arrivals__istat_2017": "1548653",
      "percent_variance_arrivals__istat_2017": "1,50%",
      "total_arrivals__istat_2017_italy": "2,20%",
      "total_arrivals__istat_2017_france": "0,30%",
      "total_arrivals__istat_2017_germany": "0,30%",
      "total_arrivals__istat_2017_united-kingdom": "0,30%",
      "total_arrivals__istat_2017_united-states": "0,20%",
      "percent_airbnb_accommodations__airbnb_2017": "8%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "55%",
      "total_attendances_airbnb__airbnb_2017": "0,53%",
      "economics_per_inhabitant__airbnb_2017": "17€",
      "percent_airbnb_5_stars_review__airbnb_2017": "58%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "1,40%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,18%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,20%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,36%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,24%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "basilicata",
      "online_accommodations__ta_2018": "1,10%",
      "accommodations_reviews__ta_2018": "0,80%",
      "percent_accommodation_satisfaction__ta_2018": "4.2%",
      "online_apartments__ta_2018": "0,70%",
      "apartments_reviews__ta_2018": "0,90%",
      "percent_apartment_satisfaction__ta_2018": "2,3%",
      "total_reviews__ta_2018": "1,70%",
      "total_reviews__ta_2018_germany": "0.3%",
      "total_reviews__ta_2018_france": "0.7%",
      "total_reviews__ta_2018_united-kingdom": "0.5%",
      "total_reviews__ta_2018_united-states": "0.7%",
      "total_reviews__ta_2018_italy": "1.6%",
      "accommodations_in_italy__istat_2017": "1326",
      "total_accommodations__istat_2017": "36072",
      "total_arrivals__istat_2017": "786775",
      "percent_variance_arrivals__istat_2017": "9,70%",
      "total_arrivals__istat_2017_italy": "1,10%",
      "total_arrivals__istat_2017_france": "0,30%",
      "total_arrivals__istat_2017_germany": "0,10%",
      "total_arrivals__istat_2017_united-kingdom": "0,30%",
      "total_arrivals__istat_2017_united-states": "0,30%",
      "percent_airbnb_accommodations__airbnb_2017": "7%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "41%",
      "total_attendances_airbnb__airbnb_2017": "0,73%",
      "economics_per_inhabitant__airbnb_2017": "12€",
      "percent_airbnb_5_stars_review__airbnb_2017": "63%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "1,44%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,72%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,20%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,00%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,62%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "calabria",
      "online_accommodations__ta_2018": "2,90%",
      "accommodations_reviews__ta_2018": "1,40%",
      "percent_accommodation_satisfaction__ta_2018": "0.9%",
      "online_apartments__ta_2018": "1,60%",
      "apartments_reviews__ta_2018": "0,90%",
      "percent_apartment_satisfaction__ta_2018": "-0,3%",
      "total_reviews__ta_2018": "2,30%",
      "total_reviews__ta_2018_germany": "0.9%",
      "total_reviews__ta_2018_france": "0.4%",
      "total_reviews__ta_2018_united-kingdom": "0.4%",
      "total_reviews__ta_2018_united-states": "0.6%",
      "total_reviews__ta_2018_italy": "1.3%",
      "accommodations_in_italy__istat_2017": "3361",
      "total_accommodations__istat_2017": "193518",
      "total_arrivals__istat_2017": "1799779",
      "percent_variance_arrivals__istat_2017": "12,30%",
      "total_arrivals__istat_2017_italy": "2,40%",
      "total_arrivals__istat_2017_france": "0,70%",
      "total_arrivals__istat_2017_germany": "0,60%",
      "total_arrivals__istat_2017_united-kingdom": "0,20%",
      "total_arrivals__istat_2017_united-states": "0,30%",
      "percent_airbnb_accommodations__airbnb_2017": "6%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "76%",
      "total_attendances_airbnb__airbnb_2017": "0,33%",
      "economics_per_inhabitant__airbnb_2017": "10€",
      "percent_airbnb_5_stars_review__airbnb_2017": "55%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "4,97%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "3,25%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "1,00%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "1,99%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "2,68%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "campania",
      "online_accommodations__ta_2018": "6,00%",
      "accommodations_reviews__ta_2018": "6,20%",
      "percent_accommodation_satisfaction__ta_2018": "0.7%",
      "online_apartments__ta_2018": "6,00%",
      "apartments_reviews__ta_2018": "6,70%",
      "percent_apartment_satisfaction__ta_2018": "0,2%",
      "total_reviews__ta_2018": "12,90%",
      "total_reviews__ta_2018_germany": "4.5%",
      "total_reviews__ta_2018_france": "7.7%",
      "total_reviews__ta_2018_united-kingdom": "11.9%",
      "total_reviews__ta_2018_united-states": "11.3%",
      "total_reviews__ta_2018_italy": "7.0%",
      "accommodations_in_italy__istat_2017": "12804",
      "total_accommodations__istat_2017": "232592",
      "total_arrivals__istat_2017": "5641166",
      "percent_variance_arrivals__istat_2017": "2,70%",
      "total_arrivals__istat_2017_italy": "5,00%",
      "total_arrivals__istat_2017_france": "5,10%",
      "total_arrivals__istat_2017_germany": "1,90%",
      "total_arrivals__istat_2017_united-kingdom": "9,00%",
      "total_arrivals__istat_2017_united-states": "7,70%",
      "percent_airbnb_accommodations__airbnb_2017": "16%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "59%",
      "total_attendances_airbnb__airbnb_2017": "2,73%",
      "economics_per_inhabitant__airbnb_2017": "40€",
      "percent_airbnb_5_stars_review__airbnb_2017": "57%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "0,69%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,23%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,14%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,13%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,19%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "emilia_romagna",
      "online_accommodations__ta_2018": "5,90%",
      "accommodations_reviews__ta_2018": "7,10%",
      "percent_accommodation_satisfaction__ta_2018": "-0.9%",
      "online_apartments__ta_2018": "3,40%",
      "apartments_reviews__ta_2018": "3,90%",
      "percent_apartment_satisfaction__ta_2018": "0,8%",
      "total_reviews__ta_2018": "11,00%",
      "total_reviews__ta_2018_germany": "3.7%",
      "total_reviews__ta_2018_france": "3.3%",
      "total_reviews__ta_2018_united-kingdom": "4.0%",
      "total_reviews__ta_2018_united-states": "2.7%",
      "total_reviews__ta_2018_italy": "8.8%",
      "accommodations_in_italy__istat_2017": "15639",
      "total_accommodations__istat_2017": "458970",
      "total_arrivals__istat_2017": "11051890",
      "percent_variance_arrivals__istat_2017": "7,10%",
      "total_arrivals__istat_2017_italy": "12,90%",
      "total_arrivals__istat_2017_france": "5,40%",
      "total_arrivals__istat_2017_germany": "4,00%",
      "total_arrivals__istat_2017_united-kingdom": "4,00%",
      "total_arrivals__istat_2017_united-states": "2,20%",
      "percent_airbnb_accommodations__airbnb_2017": "4%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "45%",
      "total_attendances_airbnb__airbnb_2017": "1,10%",
      "economics_per_inhabitant__airbnb_2017": "28€",
      "percent_airbnb_5_stars_review__airbnb_2017": "57%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "0,82%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,23%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,23%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,51%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,24%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "friuli_venezia_giulia",
      "online_accommodations__ta_2018": "1,70%",
      "accommodations_reviews__ta_2018": "2,00%",
      "percent_accommodation_satisfaction__ta_2018": "-0.2%",
      "online_apartments__ta_2018": "1,20%",
      "apartments_reviews__ta_2018": "1,80%",
      "percent_apartment_satisfaction__ta_2018": "-0,2%",
      "total_reviews__ta_2018": "3,80%",
      "total_reviews__ta_2018_germany": "2.2%",
      "total_reviews__ta_2018_france": "0.5%",
      "total_reviews__ta_2018_united-kingdom": "0.7%",
      "total_reviews__ta_2018_united-states": "0.8%",
      "total_reviews__ta_2018_italy": "1.9%",
      "accommodations_in_italy__istat_2017": "7175",
      "total_accommodations__istat_2017": "150886",
      "total_arrivals__istat_2017": "2448834",
      "percent_variance_arrivals__istat_2017": "5,50%",
      "total_arrivals__istat_2017_italy": "1,90%",
      "total_arrivals__istat_2017_france": "0,70%",
      "total_arrivals__istat_2017_germany": "1,90%",
      "total_arrivals__istat_2017_united-kingdom": "0,60%",
      "total_arrivals__istat_2017_united-states": "0,60%",
      "percent_airbnb_accommodations__airbnb_2017": "3%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "55%",
      "total_attendances_airbnb__airbnb_2017": "1,38%",
      "economics_per_inhabitant__airbnb_2017": "23€",
      "percent_airbnb_5_stars_review__airbnb_2017": "60%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "5,35%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "7,31%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "8,71%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "4,52%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "8,26%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "lazio",
      "online_accommodations__ta_2018": "8,30%",
      "accommodations_reviews__ta_2018": "11,30%",
      "percent_accommodation_satisfaction__ta_2018": "-3%",
      "online_apartments__ta_2018": "9,80%",
      "apartments_reviews__ta_2018": "15,20%",
      "percent_apartment_satisfaction__ta_2018": "0,9%",
      "total_reviews__ta_2018": "26,50%",
      "total_reviews__ta_2018_germany": "7.3%",
      "total_reviews__ta_2018_france": "10.7%",
      "total_reviews__ta_2018_united-kingdom": "17.1%",
      "total_reviews__ta_2018_united-states": "22.6%",
      "total_reviews__ta_2018_italy": "10.4%",
      "accommodations_in_italy__istat_2017": "18596",
      "total_accommodations__istat_2017": "376209",
      "total_arrivals__istat_2017": "11591827",
      "percent_variance_arrivals__istat_2017": "1,50%",
      "total_arrivals__istat_2017_italy": "6,80%",
      "total_arrivals__istat_2017_france": "9,80%",
      "total_arrivals__istat_2017_germany": "3,60%",
      "total_arrivals__istat_2017_united-kingdom": "14,40%",
      "total_arrivals__istat_2017_united-states": "25,20%",
      "percent_airbnb_accommodations__airbnb_2017": "21%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "23%",
      "total_attendances_airbnb__airbnb_2017": "4,52%",
      "economics_per_inhabitant__airbnb_2017": "154€",
      "percent_airbnb_5_stars_review__airbnb_2017": "53%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "6,80%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "2,39%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "2,00%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "3,06%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "3,48%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "liguria",
      "online_accommodations__ta_2018": "2,40%",
      "accommodations_reviews__ta_2018": "3,10%",
      "percent_accommodation_satisfaction__ta_2018": "-1.2%",
      "online_apartments__ta_2018": "5,50%",
      "apartments_reviews__ta_2018": "6,10%",
      "percent_apartment_satisfaction__ta_2018": "-1,4%",
      "total_reviews__ta_2018": "9,20%",
      "total_reviews__ta_2018_germany": "3.4%",
      "total_reviews__ta_2018_france": "11.0%",
      "total_reviews__ta_2018_united-kingdom": "3.1%",
      "total_reviews__ta_2018_united-states": "5.2%",
      "total_reviews__ta_2018_italy": "4.0%",
      "accommodations_in_italy__istat_2017": "4938",
      "total_accommodations__istat_2017": "154226",
      "total_arrivals__istat_2017": "4739935",
      "percent_variance_arrivals__istat_2017": "5,20%",
      "total_arrivals__istat_2017_italy": "4,10%",
      "total_arrivals__istat_2017_france": "8,20%",
      "total_arrivals__istat_2017_germany": "2,60%",
      "total_arrivals__istat_2017_united-kingdom": "2,50%",
      "total_arrivals__istat_2017_united-states": "3,50%",
      "percent_airbnb_accommodations__airbnb_2017": "16%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "40%",
      "total_attendances_airbnb__airbnb_2017": "2,15%",
      "economics_per_inhabitant__airbnb_2017": "146€",
      "percent_airbnb_5_stars_review__airbnb_2017": "57%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "1,48%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,36%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,35%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "1,10%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,47%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "lombardy",
      "online_accommodations__ta_2018": "8,40%",
      "accommodations_reviews__ta_2018": "12,40%",
      "percent_accommodation_satisfaction__ta_2018": "-2.4%",
      "online_apartments__ta_2018": "9,50%",
      "apartments_reviews__ta_2018": "12,10%",
      "percent_apartment_satisfaction__ta_2018": "-0,8%",
      "total_reviews__ta_2018": "24,50%",
      "total_reviews__ta_2018_germany": "16.6%",
      "total_reviews__ta_2018_france": "11.8%",
      "total_reviews__ta_2018_united-kingdom": "12.5%",
      "total_reviews__ta_2018_united-states": "10.6%",
      "total_reviews__ta_2018_italy": "11.8%",
      "accommodations_in_italy__istat_2017": "12225",
      "total_accommodations__istat_2017": "383749",
      "total_arrivals__istat_2017": "16557728",
      "percent_variance_arrivals__istat_2017": "7,40%",
      "total_arrivals__istat_2017_italy": "11,80%",
      "total_arrivals__istat_2017_france": "13,20%",
      "total_arrivals__istat_2017_germany": "11,80%",
      "total_arrivals__istat_2017_united-kingdom": "15,10%",
      "total_arrivals__istat_2017_united-states": "11,50%",
      "percent_airbnb_accommodations__airbnb_2017": "16%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "38%",
      "total_attendances_airbnb__airbnb_2017": "2,81%",
      "economics_per_inhabitant__airbnb_2017": "51€",
      "percent_airbnb_5_stars_review__airbnb_2017": "54%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "9,90%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "16,18%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "28,54%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "13,69%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "19,60%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "marche",
      "online_accommodations__ta_2018": "3,10%",
      "accommodations_reviews__ta_2018": "1,90%",
      "percent_accommodation_satisfaction__ta_2018": "1.9%",
      "online_apartments__ta_2018": "1,90%",
      "apartments_reviews__ta_2018": "1,10%",
      "percent_apartment_satisfaction__ta_2018": "1,2%",
      "total_reviews__ta_2018": "3,00%",
      "total_reviews__ta_2018_germany": "0.7%",
      "total_reviews__ta_2018_france": "0.5%",
      "total_reviews__ta_2018_united-kingdom": "0.7%",
      "total_reviews__ta_2018_united-states": "0.5%",
      "total_reviews__ta_2018_italy": "2.6%",
      "accommodations_in_italy__istat_2017": "4652",
      "total_accommodations__istat_2017": "193310",
      "total_arrivals__istat_2017": "2117055",
      "percent_variance_arrivals__istat_2017": "-10,90%",
      "total_arrivals__istat_2017_italy": "2,80%",
      "total_arrivals__istat_2017_france": "0,50%",
      "total_arrivals__istat_2017_germany": "0,50%",
      "total_arrivals__istat_2017_united-kingdom": "0,50%",
      "total_arrivals__istat_2017_united-states": "0,30%",
      "percent_airbnb_accommodations__airbnb_2017": "6%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "49%",
      "total_attendances_airbnb__airbnb_2017": "1,13%",
      "economics_per_inhabitant__airbnb_2017": "20€",
      "percent_airbnb_5_stars_review__airbnb_2017": "58%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "6,45%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "9,23%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "6,30%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "5,56%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "3,81%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "molise",
      "online_accommodations__ta_2018": "0,40%",
      "accommodations_reviews__ta_2018": "0,20%",
      "percent_accommodation_satisfaction__ta_2018": "2.6%",
      "online_apartments__ta_2018": "0,20%",
      "apartments_reviews__ta_2018": "0,10%",
      "percent_apartment_satisfaction__ta_2018": "0,7%",
      "total_reviews__ta_2018": "0,30%",
      "total_reviews__ta_2018_germany": "0.0%",
      "total_reviews__ta_2018_france": "0.0%",
      "total_reviews__ta_2018_united-kingdom": "0.1%",
      "total_reviews__ta_2018_united-states": "0.2%",
      "total_reviews__ta_2018_italy": "0.3%",
      "accommodations_in_italy__istat_2017": "508",
      "total_accommodations__istat_2017": "11866",
      "total_arrivals__istat_2017": "131050",
      "percent_variance_arrivals__istat_2017": "-4,30%",
      "total_arrivals__istat_2017_italy": "0,20%",
      "total_arrivals__istat_2017_france": "0,00%",
      "total_arrivals__istat_2017_germany": "0,00%",
      "total_arrivals__istat_2017_united-kingdom": "0,00%",
      "total_arrivals__istat_2017_united-states": "0,00%",
      "percent_airbnb_accommodations__airbnb_2017": "8%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "67%",
      "total_attendances_airbnb__airbnb_2017": "0,29%",
      "economics_per_inhabitant__airbnb_2017": "4€",
      "percent_airbnb_5_stars_review__airbnb_2017": "59%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "12,35%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "11,94%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "8,82%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "17,24%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "12,97%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "piedmont",
      "online_accommodations__ta_2018": "4,60%",
      "accommodations_reviews__ta_2018": "3,50%",
      "percent_accommodation_satisfaction__ta_2018": "1.2%",
      "online_apartments__ta_2018": "4,20%",
      "apartments_reviews__ta_2018": "3,80%",
      "percent_apartment_satisfaction__ta_2018": "0,9%",
      "total_reviews__ta_2018": "7,30%",
      "total_reviews__ta_2018_germany": "3.6%",
      "total_reviews__ta_2018_france": "6.4%",
      "total_reviews__ta_2018_united-kingdom": "2.8%",
      "total_reviews__ta_2018_united-states": "1.8%",
      "total_reviews__ta_2018_italy": "4.1%",
      "accommodations_in_italy__istat_2017": "6704",
      "total_accommodations__istat_2017": "198835",
      "total_arrivals__istat_2017": "5179986",
      "percent_variance_arrivals__istat_2017": "7,40%",
      "total_arrivals__istat_2017_italy": "5,10%",
      "total_arrivals__istat_2017_france": "7,50%",
      "total_arrivals__istat_2017_germany": "3,20%",
      "total_arrivals__istat_2017_united-kingdom": "3,80%",
      "total_arrivals__istat_2017_united-states": "1,70%",
      "percent_airbnb_accommodations__airbnb_2017": "11%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "43%",
      "total_attendances_airbnb__airbnb_2017": "1,34%",
      "economics_per_inhabitant__airbnb_2017": "28€",
      "percent_airbnb_5_stars_review__airbnb_2017": "59%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "1,80%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,30%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,20%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,51%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,33%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "apulia",
      "online_accommodations__ta_2018": "7,80%",
      "accommodations_reviews__ta_2018": "4,60%",
      "percent_accommodation_satisfaction__ta_2018": "2%",
      "online_apartments__ta_2018": "7,20%",
      "apartments_reviews__ta_2018": "4,00%",
      "percent_apartment_satisfaction__ta_2018": "-0,2%",
      "total_reviews__ta_2018": "8,60%",
      "total_reviews__ta_2018_germany": "2.3%",
      "total_reviews__ta_2018_france": "4.0%",
      "total_reviews__ta_2018_united-kingdom": "3.3%",
      "total_reviews__ta_2018_united-states": "2.0%",
      "total_reviews__ta_2018_italy": "5.2%",
      "accommodations_in_italy__istat_2017": "6883",
      "total_accommodations__istat_2017": "272970",
      "total_arrivals__istat_2017": "3911688",
      "percent_variance_arrivals__istat_2017": "4,80%",
      "total_arrivals__istat_2017_italy": "4,80%",
      "total_arrivals__istat_2017_france": "2,60%",
      "total_arrivals__istat_2017_germany": "1,20%",
      "total_arrivals__istat_2017_united-kingdom": "2,00%",
      "total_arrivals__istat_2017_united-states": "1,10%",
      "percent_airbnb_accommodations__airbnb_2017": "19%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "49%",
      "total_attendances_airbnb__airbnb_2017": "1,05%",
      "economics_per_inhabitant__airbnb_2017": "31€",
      "percent_airbnb_5_stars_review__airbnb_2017": "59%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "0,10%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,02%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,03%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,02%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,02%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "sardinia",
      "online_accommodations__ta_2018": "5,50%",
      "accommodations_reviews__ta_2018": "3,50%",
      "percent_accommodation_satisfaction__ta_2018": "0.9%",
      "online_apartments__ta_2018": "7,20%",
      "apartments_reviews__ta_2018": "4,00%",
      "percent_apartment_satisfaction__ta_2018": "0,2%",
      "total_reviews__ta_2018": "7,50%",
      "total_reviews__ta_2018_germany": "4.5%",
      "total_reviews__ta_2018_france": "5.9%",
      "total_reviews__ta_2018_united-kingdom": "3.2%",
      "total_reviews__ta_2018_united-states": "1.0%",
      "total_reviews__ta_2018_italy": "2.8%",
      "accommodations_in_italy__istat_2017": "4844",
      "total_accommodations__istat_2017": "211835",
      "total_arrivals__istat_2017": "3097366",
      "percent_variance_arrivals__istat_2017": "7,60%",
      "total_arrivals__istat_2017_italy": "2,60%",
      "total_arrivals__istat_2017_france": "6,20%",
      "total_arrivals__istat_2017_germany": "2,90%",
      "total_arrivals__istat_2017_united-kingdom": "3,00%",
      "total_arrivals__istat_2017_united-states": "0,50%",
      "percent_airbnb_accommodations__airbnb_2017": "24%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "52%",
      "total_attendances_airbnb__airbnb_2017": "1,94%",
      "economics_per_inhabitant__airbnb_2017": "130€",
      "percent_airbnb_5_stars_review__airbnb_2017": "56%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "6,86%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "5,32%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "1,14%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "2,83%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "2,22%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "sicily",
      "online_accommodations__ta_2018": "8,70%",
      "accommodations_reviews__ta_2018": "6,70%",
      "percent_accommodation_satisfaction__ta_2018": "1.6%",
      "online_apartments__ta_2018": "11,70%",
      "apartments_reviews__ta_2018": "8,50%",
      "percent_apartment_satisfaction__ta_2018": "-0,2%",
      "total_reviews__ta_2018": "15,20%",
      "total_reviews__ta_2018_germany": "7.6%",
      "total_reviews__ta_2018_france": "12.0%",
      "total_reviews__ta_2018_united-kingdom": "7.6%",
      "total_reviews__ta_2018_united-states": "6.3%",
      "total_reviews__ta_2018_italy": "6.6%",
      "accommodations_in_italy__istat_2017": "6750",
      "total_accommodations__istat_2017": "203260",
      "total_arrivals__istat_2017": "4857542",
      "percent_variance_arrivals__istat_2017": "10,20%",
      "total_arrivals__istat_2017_italy": "4,30%",
      "total_arrivals__istat_2017_france": "8,40%",
      "total_arrivals__istat_2017_germany": "2,50%",
      "total_arrivals__istat_2017_united-kingdom": "4,70%",
      "total_arrivals__istat_2017_united-states": "3,70%",
      "percent_airbnb_accommodations__airbnb_2017": "42%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "39%",
      "total_attendances_airbnb__airbnb_2017": "2,02%",
      "economics_per_inhabitant__airbnb_2017": "57€",
      "percent_airbnb_5_stars_review__airbnb_2017": "57%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "4,51%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "6,87%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,00%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "6,63%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "3,50%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "tuscany",
      "online_accommodations__ta_2018": "12,20%",
      "accommodations_reviews__ta_2018": "12,50%",
      "percent_accommodation_satisfaction__ta_2018": "-0.3%",
      "online_apartments__ta_2018": "15,30%",
      "apartments_reviews__ta_2018": "14,10%",
      "percent_apartment_satisfaction__ta_2018": "-0,4%",
      "total_reviews__ta_2018": "26,60%",
      "total_reviews__ta_2018_germany": "9.3%",
      "total_reviews__ta_2018_france": "11.6%",
      "total_reviews__ta_2018_united-kingdom": "13.4%",
      "total_reviews__ta_2018_united-states": "17.0%",
      "total_reviews__ta_2018_italy": "11.7%",
      "accommodations_in_italy__istat_2017": "14011",
      "total_accommodations__istat_2017": "559617",
      "total_arrivals__istat_2017": "13601245",
      "percent_variance_arrivals__istat_2017": "6,10%",
      "total_arrivals__istat_2017_italy": "9,80%",
      "total_arrivals__istat_2017_france": "11,80%",
      "total_arrivals__istat_2017_germany": "7,00%",
      "total_arrivals__istat_2017_united-kingdom": "12,50%",
      "total_arrivals__istat_2017_united-states": "18,40%",
      "percent_airbnb_accommodations__airbnb_2017": "17%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "33%",
      "total_attendances_airbnb__airbnb_2017": "4,87%",
      "economics_per_inhabitant__airbnb_2017": "190€",
      "percent_airbnb_5_stars_review__airbnb_2017": "55%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "8,88%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "10,10%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "3,19%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "8,52%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "7,22%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "trentino_alto_adige",
      "online_accommodations__ta_2018": "6,80%",
      "accommodations_reviews__ta_2018": "5,50%",
      "percent_accommodation_satisfaction__ta_2018": "3.9%",
      "online_apartments__ta_2018": "2,10%",
      "apartments_reviews__ta_2018": "1,90%",
      "percent_apartment_satisfaction__ta_2018": "2%",
      "total_reviews__ta_2018": "7,40%",
      "total_reviews__ta_2018_germany": "14.2%",
      "total_reviews__ta_2018_france": "0.7%",
      "total_reviews__ta_2018_united-kingdom": "1.6%",
      "total_reviews__ta_2018_united-states": "1.3%",
      "total_reviews__ta_2018_italy": "5.2%",
      "accommodations_in_italy__istat_2017": "13240",
      "total_accommodations__istat_2017": "390861",
      "total_arrivals__istat_2017": "11583192",
      "percent_variance_arrivals__istat_2017": "5,00%",
      "total_arrivals__istat_2017_italy": "8,20%",
      "total_arrivals__istat_2017_france": "1,70%",
      "total_arrivals__istat_2017_germany": "31,90%",
      "total_arrivals__istat_2017_united-kingdom": "3,80%",
      "total_arrivals__istat_2017_united-states": "1,50%",
      "percent_airbnb_accommodations__airbnb_2017": "3%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "54%",
      "total_attendances_airbnb__airbnb_2017": "0,56%",
      "economics_per_inhabitant__airbnb_2017": "53€",
      "percent_airbnb_5_stars_review__airbnb_2017": "61%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "2,64%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,28%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,59%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "4,46%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,69%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "umbria",
      "online_accommodations__ta_2018": "3,00%",
      "accommodations_reviews__ta_2018": "1,50%",
      "percent_accommodation_satisfaction__ta_2018": "2.8%",
      "online_apartments__ta_2018": "2,40%",
      "apartments_reviews__ta_2018": "2,20%",
      "percent_apartment_satisfaction__ta_2018": "1,1%",
      "total_reviews__ta_2018": "3,70%",
      "total_reviews__ta_2018_germany": "0.6%",
      "total_reviews__ta_2018_france": "0.5%",
      "total_reviews__ta_2018_united-kingdom": "0.9%",
      "total_reviews__ta_2018_united-states": "1.8%",
      "total_reviews__ta_2018_italy": "2.6%",
      "accommodations_in_italy__istat_2017": "3998",
      "total_accommodations__istat_2017": "88544",
      "total_arrivals__istat_2017": "2125056",
      "percent_variance_arrivals__istat_2017": "-10,30%",
      "total_arrivals__istat_2017_italy": "2,30%",
      "total_arrivals__istat_2017_france": "0,80%",
      "total_arrivals__istat_2017_germany": "0,50%",
      "total_arrivals__istat_2017_united-kingdom": "1,20%",
      "total_arrivals__istat_2017_united-states": "2,00%",
      "percent_airbnb_accommodations__airbnb_2017": "17%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "31%",
      "total_attendances_airbnb__airbnb_2017": "2,41%",
      "economics_per_inhabitant__airbnb_2017": "45€",
      "percent_airbnb_5_stars_review__airbnb_2017": "64%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "14,73%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "13,52%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "22,06%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "12,76%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "17,35%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "aosta_valley",
      "online_accommodations__ta_2018": "1,10%",
      "accommodations_reviews__ta_2018": "0,90%",
      "percent_accommodation_satisfaction__ta_2018": "3.6%",
      "online_apartments__ta_2018": "0,70%",
      "apartments_reviews__ta_2018": "0,60%",
      "percent_apartment_satisfaction__ta_2018": "3,2%",
      "total_reviews__ta_2018": "1,50%",
      "total_reviews__ta_2018_germany": "0.2%",
      "total_reviews__ta_2018_france": "1.0%",
      "total_reviews__ta_2018_united-kingdom": "0.8%",
      "total_reviews__ta_2018_united-states": "0.3%",
      "total_reviews__ta_2018_italy": "1.0%",
      "accommodations_in_italy__istat_2017": "1223",
      "total_accommodations__istat_2017": "55295",
      "total_arrivals__istat_2017": "1252213",
      "percent_variance_arrivals__istat_2017": "4,20%",
      "total_arrivals__istat_2017_italy": "1,20%",
      "total_arrivals__istat_2017_france": "2,30%",
      "total_arrivals__istat_2017_germany": "0,20%",
      "total_arrivals__istat_2017_united-kingdom": "2,10%",
      "total_arrivals__istat_2017_united-states": "0,40%",
      "percent_airbnb_accommodations__airbnb_2017": "9%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "47%",
      "total_attendances_airbnb__airbnb_2017": "1,99%",
      "economics_per_inhabitant__airbnb_2017": "205€",
      "percent_airbnb_5_stars_review__airbnb_2017": "62%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "1,58%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "0,49%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "0,87%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "0,53%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "0,90%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "veneto",
      "online_accommodations__ta_2018": "7,70%",
      "accommodations_reviews__ta_2018": "13,20%",
      "percent_accommodation_satisfaction__ta_2018": "-0.5%",
      "online_apartments__ta_2018": "7,80%",
      "apartments_reviews__ta_2018": "11,20%",
      "percent_apartment_satisfaction__ta_2018": "-0,2%",
      "total_reviews__ta_2018": "24,40%",
      "total_reviews__ta_2018_germany": "17.5%",
      "total_reviews__ta_2018_france": "11.1%",
      "total_reviews__ta_2018_united-kingdom": "14.9%",
      "total_reviews__ta_2018_united-states": "13.0%",
      "total_reviews__ta_2018_italy": "9.1%",
      "accommodations_in_italy__istat_2017": "62945",
      "total_accommodations__istat_2017": "750855",
      "total_arrivals__istat_2017": "19172576",
      "percent_variance_arrivals__istat_2017": "7,40%",
      "total_arrivals__istat_2017_italy": "10,60%",
      "total_arrivals__istat_2017_france": "14,40%",
      "total_arrivals__istat_2017_germany": "23,40%",
      "total_arrivals__istat_2017_united-kingdom": "19,90%",
      "total_arrivals__istat_2017_united-states": "18,90%",
      "percent_airbnb_accommodations__airbnb_2017": "4%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "40%",
      "total_attendances_airbnb__airbnb_2017": "2,37%",
      "economics_per_inhabitant__airbnb_2017": "83€",
      "percent_airbnb_5_stars_review__airbnb_2017": "54%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "7,24%",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "11,10%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "15,42%",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "15,59%",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "15,19%",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    },
    {
      "region": "all",
      "online_accommodations__ta_2018": "97145",
      "accommodations_reviews__ta_2018": "9298460",
      "percent_accommodation_satisfaction__ta_2018": "84.20%",
      "online_apartments__ta_2018": "279252",
      "apartments_reviews__ta_2018": "3740806",
      "percent_apartment_satisfaction__ta_2018": "90.60%",
      "total_reviews__ta_2018": "13039266",
      "total_reviews__ta_2018_germany": "590136",
      "total_reviews__ta_2018_france": "473196",
      "total_reviews__ta_2018_united-kingdom": "353227",
      "total_reviews__ta_2018_united-states": "176631",
      "total_reviews__ta_2018_italy": "3773254",
      "accommodations_in_italy__istat_2017": "204660",
      "total_accommodations__istat_2017": "5034784",
      "total_arrivals__istat_2017": "123195556",
      "percent_variance_arrivals__istat_2017": "5,30%",
      "total_arrivals__istat_2017_italy": "62672366",
      "total_arrivals__istat_2017_france": "4547455",
      "total_arrivals__istat_2017_germany": "12202448",
      "total_arrivals__istat_2017_united-kingdom": "3607966",
      "total_arrivals__istat_2017_united-states": "4889010",
      "percent_airbnb_accommodations__airbnb_2017": "12%",
      "percent_variance_arrivals_airbnb__airbnb_2017": "37%",
      "total_attendances_airbnb__airbnb_2017": "1,81%",
      "economics_per_inhabitant__airbnb_2017": "68€",
      "percent_airbnb_5_stars_review__airbnb_2017": "56%",
      "percent_variance_arrivals_airbnb__airbnb_2017_italy": "",
      "percent_variance_arrivals_airbnb__airbnb_2017_france": "",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-states": "",
      "percent_variance_arrivals_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_italy": "",
      "total_attendances_airbnb__airbnb_2017_france": "",
      "total_attendances_airbnb__airbnb_2017_united-states": "",
      "total_attendances_airbnb__airbnb_2017_united-kingdom": "",
      "total_attendances_airbnb__airbnb_2017_germany": "",
      "percent_variance_arrivals__istat_2017_italy": "",
      "percent_variance_arrivals__istat_2017_france": "",
      "percent_variance_arrivals__istat_2017_united-states": "",
      "percent_variance_arrivals__istat_2017_united-kingdom": "",
      "percent_variance_arrivals__istat_2017_germany": ""
    }
]

const iddDataFromJson = (json) => {

    //const allDataTypes = uniqBy(concat(DataTypes.accommodations, DataTypes.guestsSatisfactions, DataTypes.touristSource))
    const allDataTypes = keys(DataTypeDataKeyOrder)

    const IddData = allDataTypes.map((dataType, i) => {
        
        return json.map((regionData, index) => {

            const data = {
                id: index,
                region: regionData.region,
                data_type: dataType,
                data: [],
                year: null
            }

            forOwn(regionData, (v, k) => {

                const [key, additionbalKeyData] = k.split("__")
                
                if(key == dataType) {
                    const [source, year, country] = additionbalKeyData.split("_")
                    const value = v.replace(/([\%\u20AC])/g, '')
                    const measure_unit = (v.match(/([\%\u20AC])/g) || [])[0]

                    /*
                    console.log("--- --- ---")
                    console.log(regionData)
                    console.log(key)
                    console.log(source)
                    console.log(year)
                    console.log(country)
                    console.log(value)
                    console.log(measure_unit)
                    */

                    data.year = year

                    const index = DataTypeDataKeyOrder[dataType].indexOf((country || key))

                    data.data[index] = {
                        key: country || key,
                        value: isEmpty(value) ? null : value.replace(',', '.') * 1,
                        measure_unit: measure_unit,
                        source: source
                    }
                }
            })

            return data

        })

    })

    return flatten(IddData)
}

const IddData = iddDataFromJson(iddDataJson)

export default IddData



/* TEST ASYNC PAPA */

/*
function parse() {
    return new Promise(resolve => {
        Papa.parse(csvData, {
            header: true,
            download: true,
            skipEmptyLines: true,
            complete: (result) => {
                console.log(result.data)
            
                const allDataTypes = uniqBy(concat(DataTypes.accommodations, DataTypes.guestsSatisfactions, DataTypes.touristSource))
                
                const IddData = allDataTypes.map((dataType, i) => {
                    
                    return result.data.map((regionData, index) => {
            
                        const data = {
                            id: index,
                            region: regionData.region,
                            data_type: dataType,
                            data: [],
                            year: null
                        }
            
                        forOwn(regionData, (v, k) => {
                            if(startsWith(k, dataType)) {
                                const [key, additionbalKeyData] = k.split("__")
                                const [source, year, country] = additionbalKeyData.split("_")
            
                                const value = v.replace(/([\%\€])/g, '')
                                const measure_unit = (v.match(/([\%\€])/g) || [])[0]
            
                                console.log("--- --- ---")
                                console.log(regionData)
                                console.log(key)
                                console.log(source)
                                console.log(year)
                                console.log(country)
                                console.log(value)
                                console.log(measure_unit)
            
                                data.year = year
                                data.data.push({
                                    key: country || key,
                                    value: value,
                                    measure_unit: measure_unit,
                                    source: source
                                })
                            }
                        })
            
                        return data
            
                    })
            
                })
            
                resolve(flatten(IddData))
            }  
        });

    });
}
  
async function asyncSetIddData() {
    const IddData = await parse()
    console.log(IddData)
    return IddData
}
  
const IddData = asyncSetIddData()
console.log(IddData)


export default IddData
*/

/* TEST PAPA 2 */

/* 
let IddData = {}
*/
/*
const parseCsv = (result) => {
    console.log(result.data)

    const allDataTypes = uniqBy(concat(DataTypes.accommodations, DataTypes.guestsSatisfactions, DataTypes.touristSource))
    
    IddData = allDataTypes.map((dataType, i) => {
        
        return result.data.map((regionData, index) => {

            const data = {
                id: index,
                region: regionData.region,
                data_type: dataType,
                data: [],
                year: null
            }

            forOwn(regionData, (v, k) => {
                if(startsWith(k, dataType)) {
                    const [key, additionbalKeyData] = k.split("__")
                    const [source, year, country] = additionbalKeyData.split("_")

                    const value = v.replace(/([\%\€])/g, '')
                    const measure_unit = (v.match(/([\%\€])/g) || [])[0]

                    console.log("--- --- ---")
                    console.log(regionData)
                    console.log(key)
                    console.log(source)
                    console.log(year)
                    console.log(country)
                    console.log(value)
                    console.log(measure_unit)

                    data.year = year
                    data.data.push({
                        key: country || key,
                        value: value,
                        measure_unit: measure_unit,
                        source: source
                    })
                }
            })

            return data

        })

    })

    IddData = flatten(IddData)
    console.log(IddData)
}
*/

/*
Papa.parse(csvData, {
    header: true,
    download: true,
    skipEmptyLines: true,
    complete: parseCsv  
});
*/
/*
export default IddData
*/


// WEBPACK FOOTER //
// ./src/sources/mocks/data/IddData.js